<template>
    <div class="a-modal">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ id ? $lang('admin.addPartner.title') : $lang('admin.addPartner.title2') }}</span>
        </div>
        <div class="popup__content">
            <form class="form">
                <remote-host
                    v-if="partnerId"
                    ref="remoteHost"
                    :partner-id.sync="partnerId"
                />

                <remote-db
                    v-if="partnerId"
                    ref="remoteDb"
                    :partner-id.sync="partnerId"
                />

                <div class="form__item a-modal__separator">
                    <el-popover
                        popper-class="footer__lang-popover"
                        placement="bottom"
                        trigger="click">
                        <div class="footer__lang-list">
                            <div v-for="lang in langs"
                                 class="footer__lang-list__link "
                                 :class="{ 'footer__lang-list__link--active': lang.url === form.locale }"
                                 @click="changeLang(lang.url)">
                                {{ lang.name }}
                            </div>
                        </div>

                        <button slot="reference"
                                class="btn btn--white btn--small footer__lang-btn footer__lang-btn--blue"
                                @click.prevent="">
                            <svg class="footer__lang-icon footer__lang-icon--mr" width="24" height="24">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-lang-b"></use>
                            </svg>

                            <span v-for="lang in langs" v-if="lang.url === form.locale">{{ lang.name }}</span>

                            <svg class="footer__lang-icon footer__lang-icon--ml" width="10" height="6">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                            </svg>
                        </button>
                    </el-popover>

                </div>

                <div class="form__item">
                    <span class="form__label">{{ $lang('admin.addPartner.type')  }}</span>
                    <el-select slot="reference"
                               required
                               v-model="form.type"
                               :loading-text="$lang('el-select.loading')"
                               :noDataText="$lang('el-select.noDataText')"
                               :noMatchText="$lang('el-select.noMatchText')"
                               :placeholder="$lang('el.autocomplete.placeholder')">
                        <el-option v-for="type in types"
                                   :key="type.id"
                                   :label="$lang(type.title)"
                                   :value="type.id">
                        </el-option>
                    </el-select>
                </div>

                <div class="form__item form__item--inline">
                    <div class="form__inner">
                        <span class="form__label">{{ $lang('admin.addPartner.partnerId') }}</span>
                        <el-input placeholder="ID" class="input input--small a-modal__small" v-model="form.id" readonly></el-input>
                    </div>

                    <div class="form__inner">
                        <span class="form__label">{{ $lang('admin.addPartner.commission') }}</span>
                        <el-popover v-model="errors.commission.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.commission.message">
                            <el-select slot="reference"
                                       :class="{ 'add__error': errors.commission.isErrorPaint }"
                                       @focus="clearErrors"
                                       placeholder="20%"
                                       class="a-modal__small"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       v-model="form.commission" required>
                                <el-option v-for="item in commissions"
                                           :key="item"
                                           :value="item"
                                           :lable="item + '%'">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>

                    <span class="form__inner a-modal__right-hint a-modal__right-hint--big">
                        {{ $lang('admin.addPartner.code.hint') }}
                    </span>
                </div>

                <div class="form__item">
                    <span class="form__label">{{ $lang('admin.addPartner.name') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.name.placeholder')"
                                  class="input input--big"
                                  v-model="form.name">
                        </el-input>
                    </el-popover>
                </div>

                <div class="form__item">
                    <div class="a-modal__big">
                        <span class="form__label">{{ $lang('admin.addPartner.email') }}</span>
                        <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.email.message || errors.email_md5.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }" @focus="clearErrors"
                                      :placeholder="$lang('admin.addPartner.email.placeholder')" class="input input--big" v-model="form.email"></el-input>
                        </el-popover>
                        <span class="a-modal__hint">{{ $lang('admin.addPartner.email.hint') }}</span>
                    </div>
                </div>

                <div
                    v-if="partnerId"
                    class="form__item a-modal__big a-modal__separator"
                >
                    <button class="btn btn--middle btn--main-bg" :disabled="disableSetPassword" @click.prevent="setNewPassword(form.user_id)">{{ $lang('admin.addMaster.restoreButton') }}</button>
                </div>

                <span class="form__item a-modal__description">
                    {{ $lang('admin.addPartner.paymentData') }}
                </span>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('admin.addPartner.inn') }}</span>
                    <el-popover v-model="errors.payment_details.inn.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.inn.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.inn.isErrorPaint }" @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big" v-model="form.payment_details.inn"></el-input>
                    </el-popover>
                </label>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('admin.addPartner.address') }}</span>
                    <el-popover v-model="errors.payment_details.address.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.address.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.address.isErrorPaint }" @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.address.placeholder')" class="input input--big" v-model="form.payment_details.address"></el-input>
                    </el-popover>
                </label>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('admin.addPartner.bik') }}</span>
                    <el-popover v-model="errors.payment_details.bik.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.bik.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.bik.isErrorPaint }" @focus="clearErrors"
                                  placeholder="111111111" class="input input--big" v-model="form.payment_details.bik"></el-input>
                    </el-popover>
                </label>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('admin.addPartner.rc') }}</span>
                    <el-popover v-model="errors.payment_details.r_c.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.r_c.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.r_c.isErrorPaint }" @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big" v-model="form.payment_details.r_c"></el-input>
                    </el-popover>
                </div>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('admin.addPartner.kc') }}</span>
                    <el-popover v-model="errors.payment_details.k_c.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.k_c.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.payment_details.k_c.isErrorPaint }" @focus="clearErrors"
                                      placeholder="1111111111" class="input input--big" v-model="form.payment_details.k_c"></el-input>
                    </el-popover>
                </label>
                <div class="form__item a-modal__separator">
                    <label class="form__item a-modal__big">
                        <span class="form__label">{{ $lang('admin.addPartner.user') }}</span>
                        <el-popover v-model="errors.payment_details.signer.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.payment_details.signer.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.payment_details.signer.isErrorPaint }" @focus="clearErrors"
                                      :placeholder="$lang('admin.addPartner.user.placeholder')" class="input input--big" v-model="form.payment_details.signer"></el-input>
                        </el-popover>
                    </label>
                </div>
                <edit-referral ref="referralEditor"
                               :key="referralKey"
                               v-if="loaded"
                               :referral-slug.sync="form.referral_slug"
                               :referral-commission.sync="form.referral_commission"
                               :referral-enabled.sync="form.referral_enabled"
                               :referral-link-enabled.sync="form.referral_link_enabled"
                               :locale="form.locale"
                               :domains="form.domains"
                               :partner-id="form.id"
                >
                </edit-referral>

                <div>
                    <div class="form__item">
                        <el-switch inactive-text="Самовывоз" class="switch switch--small switch--label" v-model="form.pickup_enabled"></el-switch>
                    </div>

                    <div class="form__item" v-if="form.pickup_enabled">
                        <div class="form__item" v-for="(pickup, index) in form.pickups" :key="pickup.id">
                            <div class="form__item">
                                <span class="form__label">{{ $lang('admin.addPartner.pickup.label.name') }}</span>

                                <el-popover v-if="errors.pickups[index]"
                                            v-model="errors.pickups[index].name.isError"
                                            trigger="manual"
                                            placement="top"
                                            width="300"
                                            popper-class="add__error-popover"
                                            :content="errors.pickups[index].name.message">
                                    <el-input slot="reference" :class="{ 'add__error': errors.pickups[index].name.isErrorPaint }" @focus="clearErrors"
                                              :placeholder="$lang('admin.addPartner.name.placeholder')" class="input input--big" v-model="pickup.name"></el-input>
                                </el-popover>
                            </div>

                            <label class="form__item a-modal__big">
                                <span class="form__label">{{ $lang('admin.addPartner.pickup.label.region') }}</span>

                                <el-popover v-if="errors.pickups[index]"
                                            v-model="errors.pickups[index].region_id.isError"
                                            trigger="manual"
                                            placement="top"
                                            width="300"
                                            popper-class="add__error-popover"
                                            :content="errors.pickups[index].region_id.message">
                                    <el-select slot="reference"
                                               :class="{ 'add__error': errors.pickups[index].region_id.isErrorPaint}"
                                               v-model="pickup.region_id"
                                               :loading-text="$lang('el-select.loading')"
                                               :noDataText="$lang('el-select.noDataText')"
                                               :noMatchText="$lang('el-select.noMatchText')"
                                               filterable
                                               clearable
                                               @focus="clearErrors"
                                               :placeholder="$lang('admin.addPartner.pickup.region.placeholder')">
                                        <el-option v-for="region in regions"
                                                   :key="region.id"
                                                   :label="region.name"
                                                   :value="region.id">
                                        </el-option>
                                    </el-select>
                                </el-popover>
                            </label>

                            <label class="form__item a-modal__big">
                                <span class="form__label">{{ $lang('admin.addPartner.pickup.label.address') }}</span>

                                <el-popover v-if="errors.pickups[index]"
                                            v-model="errors.pickups[index].address.isError"
                                            trigger="manual"
                                            placement="top"
                                            width="300"
                                            popper-class="add__error-popover"
                                            :content="errors.pickups[index].address.message">
                                    <el-input slot="reference"
                                              :class="{ 'add__error': errors.pickups[index].address.isErrorPaint }"
                                              @focus="clearErrors"
                                              :placeholder="$lang('admin.addPartner.address')"
                                              class="input input--big"
                                              maxlength="150"
                                              v-model="pickup.address"></el-input>
                                </el-popover>
                            </label>

                            <label class="form__item a-modal__big">
                                <span class="form__label">{{ $lang('admin.addPartner.pickup.label.hours') }}</span>

                                <el-popover v-if="errors.pickups[index]"
                                            v-model="errors.pickups[index].hours.isError"
                                            trigger="manual"
                                            placement="top"
                                            width="300"
                                            popper-class="add__error-popover"
                                            :content="errors.pickups[index].hours.message">
                                    <el-input slot="reference"
                                              :class="{ 'add__error': errors.pickups[index].hours.isErrorPaint }"
                                              @focus="clearErrors"
                                              :placeholder="$lang('admin.addPartner.pickup.hours.placeholder')"
                                              class="input input--big"
                                              maxlength="150"
                                              v-model="pickup.hours"></el-input>
                                </el-popover>
                            </label>

                            <button class="btn btn--middle btn--main-bg"
                                    @click.prevent="removePickup(pickup, index)"
                            >
                                Удалить
                            </button>
                        </div>

                        <button class="btn btn--middle btn--main-bg"
                                @click.prevent="addPickup">+ {{ $lang('admin.addPartner.pickup.addPickupButton')}}</button>
                    </div>
                </div>
            </form>
        </div>
        <div class="popup__footer">
            <button class="btn btn--middle btn--main-bg" @click.prevent="submit">{{ $lang('admin.addPartner.save') }}</button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import mixin from '../../../mixins/errors';
    import userEdit from "../../../mixins/userEdit";
    import RemoteHost from "../../remote/Host";
    import RemoteDb from "../../remote/Db";
    import EditReferral from "./EditReferral";
    import Vue from "vue";
    import ApiService from "../../../api/api";

    export default {
        name: "EditPartner",
        mixins: [mixin, userEdit],
        components: {EditReferral, RemoteHost, RemoteDb},
        data: () => ({
            loaded: false,
            partnerId: null,
            commissions: [3, 5, 10, 15, 20, 25, 30, 40],
            referralKey: 0,
            errors: {
                type: {
                    isError: false,
                    message: ''
                },
                name: {
                    isError: false,
                    message: ''
                },
                email: {
                    isError: false,
                    message: ''
                },
                email_md5: {
                    isError: false,
                    message: ''
                },
                commission: {
                    isError: false,
                    message: ''
                },
                payment_details: {
                    inn: { isError: false, message: ''},
                    address: { isError: false, message: ''},
                    bik: { isError: false, message: ''},
                    r_c: { isError: false, message: ''},
                    k_c: { isError: false, message: ''},
                    signer: { isError: false, message: ''},
                },
                pickups: []
            },
            langs: window.laravel.langs,
            types: window.laravel.partnerTypes,
            regions: [],
            formIsBlocked: false
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
            ...mapState('createPartner', {
                storeForm: state => state.form
            }),
            form: {
                get() {
                    return this.storeForm;
                },
                set(val) {
                    this.setForm(val);
                }
            }
        },
        methods: {
            ...mapActions('user', [
                'resetPassword',
            ]),
            ...mapActions('createPartner', [
                'createPartner',
                'updatePartner',
                'resetForm',
            ]),
            ...mapMutations('partner', [
                'updatePartnerState',
                'addPartner',
            ]),
            ...mapMutations('createPartner', [
                'setForm'
            ]),
            ...mapActions('partner', [
                'getPartner',
            ]),
            submit() {
                if (this.formIsBlocked) {
                    return;
                }

                this.formIsBlocked = true;

                this.id ? this.update() : this.create()
            },
            update() {
                this.updatePartner({id: this.id, form: this.form})
                    .then((response) => {
                        this.updatePartnerState(response.data);
                        this.resetFormData();

                        this.$appNotify.success(Vue.prototype.$lang('admin.addPartner.saved1'));
                        this.$router.push({name:'partners'});
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.formIsBlocked = false;
                    });
            },
            create() {
                this.createPartner(this.form)
                    .then((response) => {
                        this.addPartner(response.data);
                        this.resetFormData();

                        this.$appNotify.success(Vue.prototype.$lang('admin.addPartner.saved2'));
                        this.$router.push({name:'partners'});
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.formIsBlocked = false;
                    });
            },
            resetFormData() {
                if (this.$refs.hasOwnProperty('remoteHost')) {
                    this.$refs.remoteHost.$emit('reset-form');
                }

                if (this.$refs.hasOwnProperty('remoteDb')) {
                    this.$refs.remoteDb.$emit('reset-form');
                }

                if (this.$refs.hasOwnProperty('referralEditor') && this.loaded) {
                    this.$refs.referralEditor.$emit('reload');
                }

                this.resetForm();
            },
            changeLang(val) {
                this.form.locale = val;

                /*Перезагружаем компонент реферальной ссылки, чтобы подставить туда новую ссылку изходя из выбранной
                локали*/
                this.referralKey++;
            },
            addPickup() {
                this.form.pickups.push({
                    name: '',
                    region_id: '',
                    address: '',
                    hours: ''
                });

                this.addPickupError();
            },
            addPickupError() {
                this.errors.pickups.push({
                    name: { isError: false, message: this.$lang('admin.addPartner.pickup.addPickupErrorMessage.name')},
                    region_id: { isError: false, message: this.$lang('admin.addPartner.pickup.addPickupErrorMessage.region')},
                    address: { isError: false, message: this.$lang('admin.addPartner.pickup.addPickupErrorMessage.address')},
                    hours: { isError: false, message: this.$lang('admin.addPartner.pickup.addPickupErrorMessage.hours')},
                });
            },
            getRegions(locale) {
                ApiService.get('/regions', {'locale': locale}).then((response) => {
                    this.regions = response.data;
                });
            },
            removePickup(pickup, index) {
                this.form.pickups.splice(index, 1);
                this.errors.pickups.splice(index, 1);

                if (pickup.id) {
                    ApiService.delete('/partner/destroy-pickup/' + pickup.id);
                }

                if (!this.form.pickups.length) {
                    this.form.pickup_enabled = false;
                }
            }
        },
        watch: {
            'form.pickup_enabled': {
                handler: function(val) {
                    if (val && !this.form.pickups.length) {
                        this.addPickup();
                    }
                },
                deep: true
            },
            'form.locale': {
                handler: function(locale) {
                    this.getRegions(locale);
                },
                deep: true
            }
        },
        mounted() {
            if (this.id) {
                this.$set(this, 'partnerId', Number.parseInt(this.id));

                this.getPartner(this.id)
                    .then((response) => {
                        let form = this.getDataObject(
                            [
                                'user_id','name', 'email',
                                'payment_details', 'commission',
                                'id', 'referral_slug',
                                'referral_commission',
                                'referral_enabled', 'locale',
                                'pickup_enabled', 'pickups',
                                'domains', 'referral_link_enabled',
                                'type'
                            ],
                            response.data,
                            [
                                'user.id', 'user.name', 'user.email',
                                'payment_details', 'commission',
                                'id', 'referral_slug',
                                'referral_commission',
                                'referral_enabled', 'locale',
                                'pickup_enabled', 'pickups',
                                'domains', 'referral_link_enabled',
                                'type'
                            ]
                        );

                        this.$set(this, 'form', form);

                        this.loaded = true;

                        if(form.pickups.length) {
                            form.pickups.forEach(() => {
                                this.addPickupError();
                            });
                        }
                    })
            } else {
                if (!this.loaded) {
                    this.getRegions(this.form.locale);
                }

                this.loaded = true;
            }
        },
        beforeDestroy() {
            if (this.id) {
                this.resetFormData();
            }
        }
    }
</script>
